import screens from '@onereach/styles/screens.json';
import { useMediaQuery } from '@vueuse/core';
import { getCurrentInstance, ref, watch, onMounted, isVue3, computed } from 'vue-demi';

function useResponsive(element) {
  const currentInstance = getCurrentInstance();
  const currentRootElement = ref();
  if (element) {
    watch(element, value => {
      currentRootElement.value = value;
    });
  } else {
    onMounted(() => {
      if (currentInstance) {
        const element = currentInstance.vnode[isVue3 ? 'el' : 'elm'];
        if (element instanceof Element) {
          currentRootElement.value = element;
        }
      }
    });
  }
  // State
  const isDesktop = computed(() => {
    return isForcedDesktop(currentRootElement.value) || desktopQuery.value;
  });
  const isMobile = computed(() => {
    return !isDesktop.value;
  });
  const desktopQuery = useMediaQuery(`(min-width: ${screens.md})`);
  // Helpers
  function isForcedDesktop(element) {
    var _a, _b;
    if (!element) {
      return false;
    }
    const forcedScreens = (_a = element.getAttribute('force-screen')) === null || _a === void 0 ? void 0 : _a.split(/\s+/);
    if (forcedScreens === null || forcedScreens === void 0 ? void 0 : forcedScreens.some(forcedScreen => ['md', 'lg', 'xl'].includes(forcedScreen))) {
      return true;
    }
    return isForcedDesktop((_b = element.parentElement) !== null && _b !== void 0 ? _b : undefined);
  }
  return {
    isDesktop,
    isMobile
  };
}

export { useResponsive as u };
